
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const leftNavItems = [
    { name: '首页', href: '/' },
    { name: '品牌故事', href: '#story' },
    { name: '产品中心', href: '#products' }
  ];

  const rightNavItems = [
    { name: '荣誉认证', href: '/honors' },
    { name: '服务体验', href: '#services' },
    { name: '最新动态', href: '#news' },
    { name: '联系合作', href: '/contact' }
  ];

  const handleNavClick = (href: string) => {
    if (href.startsWith('/')) {
      // 页面路由 - 跳转到其他页面
      if (location.pathname !== href) {
        window.REACT_APP_NAVIGATE(href);
        // 确保页面跳转后滚动到顶部
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      } else {
        // 如果已经在当前页面，滚动到顶部
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      // 锚点链接 - 处理页面内滚动
      if (location.pathname !== '/') {
        // 如果不在首页，先跳转到首页再滚动到对应区域
        window.REACT_APP_NAVIGATE('/');
        setTimeout(() => {
          const element = document.querySelector(href);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 300);
      } else {
        // 如果在首页，直接滚动到对应区域
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className="relative">
        {/* Main Navigation Bar */}
        <div className="bg-primary px-4 lg:px-8">
          <div className="relative flex items-center h-14 lg:h-16">
            {/* Left Navigation */}
            <nav className="hidden lg:flex items-center space-x-6 flex-1 justify-start">
              {leftNavItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => handleNavClick(item.href)}
                  className="text-white hover:text-accent transition-colors duration-300 text-sm font-medium cursor-pointer whitespace-nowrap"
                >
                  {item.name}
                </button>
              ))}
            </nav>

            {/* Mobile Menu Button - Left with margin */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden text-white hover:text-accent transition-colors duration-300 cursor-pointer z-40 relative p-2 ml-2"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>

            {/* 中央白色Logo区域 */}
            <div className="absolute left-1/2 transform -translate-x-1/2 top-0 z-20 pointer-events-none">
              <div className="bg-white rounded-b-xl px-2 lg:px-4 py-1 pb-6 lg:pb-10 shadow-lg max-w-[120px] lg:max-w-none">
                <div className="flex flex-col items-center">
                  <img 
                    src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/cdcca46642fbb151076a4d1f00d59153.png"
                    alt="马帮瑞贡"
                    className="w-16 h-12 lg:w-24 lg:h-18 object-contain"
                  />
                </div>
              </div>
            </div>

            {/* Right Navigation */}
            <nav className="hidden lg:flex items-center space-x-6 flex-1 justify-end">
              {rightNavItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => handleNavClick(item.href)}
                  className="text-white hover:text-accent transition-colors duration-300 text-sm font-medium cursor-pointer whitespace-nowrap"
                >
                  {item.name}
                </button>
              ))}
            </nav>

            {/* Mobile Contact Button - Right with margin */}
            <button 
              onClick={() => handleNavClick('/contact')}
              className="lg:hidden text-white hover:text-accent transition-colors duration-300 cursor-pointer z-40 relative p-2 mr-2 ml-auto"
            >
              <i className="ri-phone-line text-xl"></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <nav className="lg:hidden bg-primary border-t border-gray-600">
              <div className="py-3 space-y-2">
                {[...leftNavItems, ...rightNavItems].map((item) => (
                  <button
                    key={item.name}
                    onClick={() => handleNavClick(item.href)}
                    className="block w-full text-left px-4 py-2 text-white hover:text-accent transition-colors duration-300 text-sm cursor-pointer"
                  >
                    {item.name}
                  </button>
                ))}
              </div>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
